// Función para determinar el tipo de archivo basado en su extensión
export const getFileType = (fileName) => {
  if (!fileName) return 'other';
  
  const extension = fileName.split('.').pop().toLowerCase();
  
  if (['jpg', 'jpeg', 'png', 'gif', 'svg', 'webp', 'bmp'].includes(extension)) {
    return 'image';
  }
  
  if (extension === 'pdf') {
    return 'pdf';
  }
  
  if (['txt', 'md', 'log'].includes(extension)) {
    return 'text';
  }
  
  // Archivos de Office y otros documentos
  if (['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'zip', 'rar', '7z', 'csv'].includes(extension)) {
    return 'download';
  }
  
  return 'other';
};

// Función para obtener el icono apropiado según el tipo de archivo
export const getFileIcon = (fileName) => {
  const fileType = getFileType(fileName);
  
  switch (fileType) {
    case 'image':
      return '🖼️';
    case 'pdf':
      return '📄';
    case 'text':
      return '📝';
    case 'download':
      return '📎';
    default:
      return '📁';
  }
};

